// Hex values reused across InvoiceDetailDrawer's sub-components, extracted
// here so each literal is defined once instead of being duplicated per file.
//
// These are plain hex constants, not theme.palette.* tokens (see design.md) —
// mapping them to the theme would require a broader design-system decision
// that is out of scope for this component family.

// Muted uppercase label text (stat labels, drawer eyebrow title)
export const MUTED_LABEL_COLOR = '#68717d';

// Primary dark heading/value text (stat values, folio, amounts, card titles)
export const HEADING_TEXT_COLOR = '#2B2D42';

// Hairline divider/border between rows and card sections
export const HAIRLINE_BORDER_COLOR = '#edf1f5';

// Link-styled folio text — matches theme.palette.secondary.edit, already used
// for the same purpose (invoice/contract folio links) in AccountStatementRow.js
export const LINK_COLOR = '#5C95FF';

// Gray page canvas the content area sits on (factura-detalle.html's --bg),
// matching GlobalStyles.js's body background (#F1F1F4) — white cards float
// on top of this, same pattern used by every other page in the app.
export const CONTENT_CANVAS_COLOR = '#f3f4f7';
